import { render, staticRenderFns } from "./DesignerNotifyCard.vue?vue&type=template&id=54510414"
import script from "./DesignerNotifyCard.vue?vue&type=script&lang=ts"
export * from "./DesignerNotifyCard.vue?vue&type=script&lang=ts"
import style0 from "./DesignerNotifyCard.vue?vue&type=style&index=0&id=54510414&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports